import React, { useEffect, useState } from 'react';
import styles from '../styles.module.scss';
import { priceType } from '@Redux/search/interfaces';
import { formatPrice } from '@utils/utils';
import { Slider } from '@lion-design/core';

export interface IBarProps {
    Currency: string; // 幣別
    minPrice: number; // 最小價錢 ex: 0
    maxPrice: number; // 最大價錢 ex: 99999
    setRange: number[]; // 設定bar目前要拉到哪個位置 ex:[3333, 55555]
    mouseupChange: (value: number[], onDragBtn: string) => void; // 放開拉霸觸發
}

const PriceRangeItem: React.FC<IBarProps> = (props) => {
    const moduleName = 'priceBar';
    const { Currency, minPrice, maxPrice, setRange, mouseupChange } = props;

    // //百分比 轉數字
    const getNewMinMax = (percentArr: number[]) => {
        const per = (maxPrice - minPrice) / 100;
        const newMin = Math.round(minPrice + percentArr[0] * per);
        const newMax = Math.round(maxPrice - (100 - percentArr[1]) * per);
        return [newMin, newMax];
    };

    // // 數字轉 百分比
    const getNewPercent = (percentArr: number[]) => {
        const per = (maxPrice - minPrice) / 100 || 1;
        const minPercent = (percentArr[0] - minPrice) / per;
        const maxPercent = (percentArr[1] - minPrice) / per;

        return [minPercent, maxPercent];
    };

    //數字 arry
    const [price, setPrice] = React.useState<number[]>([setRange[0], setRange[1]]);
    const currentMin = price[0];
    const currentMax = price[1];
    //百分比 array
    const [percent, setPercent] = React.useState<number[]>(
        getNewPercent([setRange[0], setRange[1]])
    );
    // 哪個按鈕被拖動中
    const [onDragBtn, setOnDragBtn] = useState<string>('');

    // mouseup 觸發change
    const onAfterChange = (value: number[]) => {
        const newPriceArr = getNewMinMax(value);
        setPercent(value);
        mouseupChange(newPriceArr, onDragBtn);
    };

    // 拖拉過程觸發 change
    const onChange = (value: number[]) => {
        const newPriceArr = getNewMinMax(value);
        setPrice(newPriceArr);
    };

    useEffect(() => {
        setOnDragBtn(priceType.min);
    }, [currentMin]);
    useEffect(() => {
        setOnDragBtn(priceType.max);
    }, [currentMax]);
    useEffect(() => {
        setPercent(getNewPercent([setRange[0], setRange[1]]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setRange]);

    return (
        <div className={styles[`${moduleName}`]}>
            <div className={styles.PriceText}>
                <span className={styles.Currency}>{Currency}</span>
                <span className={styles.PriceRange}>
                    {`${formatPrice(price[0])}~${formatPrice(price[1])}`}
                </span>
            </div>
            <Slider defaultValue={percent} onAfterChange={onAfterChange} onChange={onChange} />
        </div>
    );
};

export default PriceRangeItem;
